import React, { Component } from 'react'
import cx from 'classnames'
import memoize from 'memoize-one'
import { Autocomplete, Loader, Icon } from '@manychat/manyui'

import {
  prepareGroupedOption,
  isNeedGroupOption,
} from 'common/filter/components/Condition/ConditionValue/FieldValuePicker/utils'

import SearchInput from '../SearchInput'

import cm from './FieldValuePicker.module.css'

export default class FieldValuePicker extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.fieldDesc.id !== this.props.fieldDesc.id) {
      this.props.fetchFieldValues(this.props.fieldDesc.id, '')
    }
  }

  getOptions = memoize((options) => {
    return options
      .filter(
        (o) =>
          o.active && ['follow-up eligible', 'outside 24+1 window'].every((v) => o.value !== v),
      )
      .map((o) => ({ ...o, value: o.value || (o.segment_id ? o.segment_id.split('_')[1] : null) }))
  })

  handleValueChange = ({ target }) => {
    const { option } = target
    const event = { target: { ...target, value: option.value } }
    this.props.onChange(event, true)
  }

  handleInputRef = (el) => el && el.select()

  getRenderOptions = (option, label) => {
    const warningLayoutFbPolicy = (
      <div className="o-hidden">
        <div className="row gutter p-x p-y-xs">
          <Icon.Warning
            className="text-warning"
            size={16}
            style={{ position: 'relative', top: '5px' }}
            data-title={
              'Kindly note that this filter will be converted into the “Outside 24 hour window” filter after March 4th, 2020 according to the Facebook policy update.'
            }
          />
          <div className={cx('col', cm.optionLabel)}>{label}</div>
          <div className="col-auto text-secondary">{option.count}</div>
        </div>
      </div>
    )

    const defaultLayout = (
      <div className="o-hidden">
        <div className="row gutter p-x p-y-xs">
          <div className={cx('col', cm.optionLabel)}>{label}</div>
          <div className="col-auto text-secondary">{option.count}</div>
        </div>
      </div>
    )

    switch (option.value) {
      case 'follow-up eligible':
      case 'outside 24+1 window':
        return warningLayoutFbPolicy
      default:
        return defaultLayout
    }
  }

  render() {
    const { condition, items, fetching } = this.props
    const options = this.getOptions(items)
    const showSearch = options.length > 8

    const preparedOptions = isNeedGroupOption(options) ? prepareGroupedOption(options) : options

    return (
      <div className={cm.wrapper}>
        {fetching ? (
          <Loader />
        ) : (
          <Autocomplete
            ref={this.handleInputRef}
            options={preparedOptions}
            value={condition.value}
            onChange={this.handleValueChange}
            noPortal
            noClearOnEmpty
            allowNew={false}
            customInput={<SearchInput hidden={!showSearch} />}
            renderOption={this.getRenderOptions}
          />
        )}
      </div>
    )
  }
}
